<template>
  <div
    data-slot="condition-connector"
    :class="[
      'flex w-6 shrink-0 flex-col items-center justify-between rounded-md text-white transition-opacity select-none',
      modelValue === 'AND' ? 'bg-primary' : 'bg-primary/45',
      disabled ? '' : 'cursor-pointer hover:opacity-80',
    ]"
    :title="disabled ? null : tr('Switch between AND and OR')"
    @click="() => changeValue()"
  >
    <span />
    <span v-if="itemCount > 1" class="-rotate-90 text-xs font-semibold whitespace-nowrap">{{ tr(modelValue) }}</span>

    <ui-dropdown-menu v-if="!disabled && allowAddNewGroup" :open="dropdownIsOpen" @update:open="(value) => dropdownIsOpen = value">
      <ui-dropdown-menu-trigger as-child>
        <button
          type="button"
          data-slot="condition-connector-add"
          :class="[ 'flex w-6 cursor-pointer items-center justify-center rounded-md hover:bg-white/30', itemCount > 1 ? 'h-6' : 'h-full min-h-9' ]"
          :aria-label="tr('Add new condition row')"
          @click.stop
        >
          <plus-icon class="size-3.5" />
        </button>
      </ui-dropdown-menu-trigger>
      <ui-dropdown-menu-content align="start">
        <ui-dropdown-menu-item @select="() => addNewItem()">{{ tr('Add new condition row') }}</ui-dropdown-menu-item>
        <ui-dropdown-menu-item @select="() => addNewGroup()">{{ tr('Add new group') }}</ui-dropdown-menu-item>
      </ui-dropdown-menu-content>
    </ui-dropdown-menu>
    <button
      v-else-if="!disabled"
      type="button"
      data-slot="condition-connector-add"
      :class="[ 'flex w-6 cursor-pointer items-center justify-center rounded-md hover:bg-white/30', itemCount > 1 ? 'h-6' : 'h-full min-h-9' ]"
      :aria-label="tr('Add new condition row')"
      @click.stop="() => addNewItem()"
    >
      <plus-icon class="size-3.5" />
    </button>
    <span v-else />
  </div>
</template>

<script>
import { Plus } from '@lucide/vue';

/** AND/OR bar of a condition group (click toggles) with the "add" menu. */
export default {
  name: 'ConditionConnector',
  components: {
    PlusIcon: Plus,
  },
  props: {
    modelValue: {
      type: String,
      required: false,
      default: () => 'OR',
    },
    itemCount: {
      type: Number,
      required: false,
      default: () => 1,
    },
    allowAddNewGroup: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  emits: [ 'update:modelValue', 'add-item', 'add-group' ],
  data: () => ({
    dropdownIsOpen: false,
  }),
  methods: {
    changeValue() {
      if (!this.disabled) {
        this.$emit('update:modelValue', this.modelValue === 'OR' ? 'AND' : 'OR');
      }
    },
    addNewItem() {
      this.$emit('add-item');
      this.dropdownIsOpen = false;
    },
    addNewGroup() {
      this.$emit('add-group');
      this.dropdownIsOpen = false;
    },
  },
};
</script>
